import { create } from "zustand";

type AuthMode = "login" | "signUp";
type StatusMode = "success" | "failed" | "sellerInfo" | null;

interface AuthModalStore {
  authOpen: boolean;
  authMode: AuthMode;
  openAuthModal: (mode: AuthMode) => void;
  closeAuthModal: () => void;

  statusOpen: boolean;
  statusMode: StatusMode;
  openStatusModal: (mode: StatusMode) => void;
  closeStatusModal: () => void;
}

export const useAuthModalStore = create<AuthModalStore>((set) => ({
  authOpen: false,
  authMode: "login",
  openAuthModal: (mode) => set(() => ({ authOpen: true, authMode: mode })),
  closeAuthModal: () => set(() => ({ authOpen: false })),

  statusOpen: false,
  statusMode: null,
  openStatusModal: (mode) =>
    set(() => ({ statusOpen: true, statusMode: mode })),
  closeStatusModal: () => set(() => ({ statusOpen: false, statusMode: null })),
}));
